export * from './format-number'

export const clamp = (value: number, min = 0, max = 100) => {
  return Math.max(min, Math.min(max, value))
}

export const round = (value: number, decimalPlaces = 0) => {
  return Math.round(value * 10 ** decimalPlaces) / 10 ** decimalPlaces
}
